module.exports = __webpack_public_path__ + "img/blue.29ee684c.png";